// removed by extract-text-webpack-plugin
module.exports = {"Live":"LiveLabel__Live__KPF_G","blink":"LiveLabel__blink__2QMKh"};